import { DecimalInput } from '@framework/form/inputs/DecimalInput.tsx';
import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';
import { type INumberWidget } from './INumberWidget.ts';

export interface INumberWidgetComponentProps
  extends IWidgetComponentProps<INumberWidget> {}

export function NumberWidgetComponent(props: INumberWidgetComponentProps) {
  const options = getWidgetProps(props);

  const valueRange = props.widget.rules?.valueRange;
  const positive = props.widget.rules?.positive?.value;
  const integer = props.widget.rules?.integer?.value;
  const decimalPlaces = props.widget.decimalSize ?? undefined;

  const valueRangeMin = valueRange?.min ?? (positive ? 0 : undefined);

  return (
    <ConfigFormItem
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options.helpText ? (
          <RichTextAdvancedRender inline text={options.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      {decimalPlaces || !integer ? (
        <DecimalInput
          readOnly={props.readonly}
          name={options.name}
          placeholder={options.placeholder}
          value={options.value as any}
          tabIndex={options.preview ? -1 : undefined}
          decimalPlaces={decimalPlaces}
          asNumber
        />
      ) : (
        <NumberInput
          readOnly={props.readonly}
          name={options.name}
          placeholder={options.placeholder}
          value={options.value as any}
          // Il minimo e il massimo creano dei bug in fase di scrittura.
          // min={valueRangeMin ?? undefined}
          // max={valueRange?.max ?? undefined}
          step={integer ? 1 : undefined}
          tabIndex={options.preview ? -1 : undefined}
        />
      )}
    </ConfigFormItem>
  );
}
